/**
 * Palmiye Gurme — sepet deneyimi (Tur 6)
 *
 * 1) Sepete ekleme bildirimi
 *    - Ürün eklenince hızlı ekle / hızlı bakış penceresi kapanır (çekmece arkada kalıyordu).
 *    - Sepet çekmecesi açılmadıysa (ör. ayar "no_action", sepet sayfası) alt/üst köşede bildirim gösterilir.
 *    - Header sepet ikonunda kısa bir vurgu animasyonu oynar.
 *    - Hata (stok yetersiz vb.) aynı bileşenle gösterilir.
 *
 * 2) Birleştirilmiş sepet satırları (snippets/pg-cart-line-group.liquid)
 *    Otomatik indirimler aynı varyantı birden fazla satıra bölebilir. Liquid bunları tek satır gösterir;
 *    bu modül o satırdaki adet / kaldır işlemlerini yakalayıp varyantın TÜM satırlarını tek istekle günceller.
 *
 * Bağımlılık: Kalles ThemeEvents adları (cart:update, cart:error, cart:reload, quantity-selector:update).
 */
(() => {
  if (window.__pgCartUx) return;
  window.__pgCartUx = true;

  const ROOT = window.Shopify?.routes?.root || '/';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const esc = (value) =>
    String(value ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  const isOpen = (el) => !!el && (el.hasAttribute('open') || el.open === true);

  /* ---------------------------------------------------------------- toast */
  const toastRoot = () => document.getElementById('PgCartToast');
  let hideTimer = null;

  function hideToast() {
    const root = toastRoot();
    if (!root) return;
    root.classList.remove('is-visible');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(() => { root.hidden = true; root.innerHTML = ''; }, reduceMotion ? 0 : 250);
  }

  function showToast({ title, variant, quantity, image, error }) {
    const root = toastRoot();
    if (!root) return;
    const d = root.dataset;
    const img = image
      ? `<img class="pg-cart-toast__img" src="${esc(image)}${image.includes('?') ? '&' : '?'}width=120" width="56" height="56" alt="" loading="eager">`
      : '';
    const heading = error ? esc(d.errorTitle) : esc(d.added);
    const icon = error
      ? '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"/></svg>'
      : '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/></svg>';
    const meta = [variant, quantity ? `${esc(d.qtyLabel)}: ${quantity}` : ''].filter(Boolean).map(esc).join(' · ');

    root.classList.toggle('is-error', !!error);
    root.innerHTML = `
      <div class="pg-cart-toast__head">
        <span class="pg-cart-toast__icon">${icon}</span>
        <strong class="pg-cart-toast__heading">${heading}</strong>
        <button type="button" class="pg-cart-toast__close" aria-label="${esc(d.close)}" data-pg-toast-close>
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M6 18 18 6M6 6l12 12"/></svg>
        </button>
      </div>
      <div class="pg-cart-toast__body">
        ${img}
        <div class="pg-cart-toast__text">
          ${title ? `<span class="pg-cart-toast__title">${esc(title)}</span>` : ''}
          ${meta ? `<span class="pg-cart-toast__meta">${meta}</span>` : ''}
          ${error ? `<span class="pg-cart-toast__meta">${esc(error)}</span>` : ''}
        </div>
      </div>
      ${error ? '' : `<a class="pg-cart-toast__cta" href="${esc(d.cartUrl)}">${esc(d.view)}</a>`}`;
    placeToast(root);
    root.hidden = false;
    // reflow → geçiş animasyonu
    void root.offsetWidth;
    root.classList.add('is-visible');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hideToast, error ? 6000 : 4500);
  }

  document.addEventListener('click', (e) => {
    if (e.target.closest?.('[data-pg-toast-close]')) hideToast();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && toastRoot() && !toastRoot().hidden) hideToast();
  });

  function bumpCartIcon() {
    if (reduceMotion) return;
    document.querySelectorAll('hdt-cart-count').forEach((el) => {
      const target = el.closest('a, button') || el;
      target.classList.remove('pg-cart-bump');
      void target.offsetWidth;
      target.classList.add('pg-cart-bump');
      setTimeout(() => target.classList.remove('pg-cart-bump'), 700);
    });
  }

  function closeProductModals() {
    ['hdt-quick-add-modal', 'hdt-quick-view-modal'].forEach((id) => {
      const dialog = document.getElementById(id);
      if (!isOpen(dialog)) return;
      // Bileşenin kendi kapat düğmesi (kullanıcı tıklamasıyla aynı yol: animasyon + scroll-lock temizliği)
      const closeBtn = dialog.querySelector('[ref="closeButton"], .hdt-dialog-btn__close');
      if (closeBtn) closeBtn.click();
      else dialog.parentElement?.close?.();
    });
  }

  /* Açık bir modal <dialog> "top layer"da olduğundan sabit konumlu toast onun altında kalır;
     modal hâlâ açıksa toast'u geçici olarak modalın içine taşı. */
  function placeToast(root) {
    let host = document.body;
    try {
      const modal = document.querySelector('dialog:modal');
      if (modal) host = modal;
    } catch (_) { /* :modal desteklenmiyor */ }
    if (root.parentElement !== host) host.appendChild(root);
  }

  function addedItem(cartData) {
    if (!cartData) return null;
    const item = Array.isArray(cartData.items) ? cartData.items[cartData.items.length - 1] : cartData;
    if (!item || !item.product_title) return null;
    const variant = item.variant_title && !/default title/i.test(item.variant_title) ? item.variant_title : '';
    return { title: item.product_title, variant, quantity: item.quantity, image: item.image || item.featured_image?.url || '' };
  }

  /* ----------------------------------------- sepete ekleme akışı (Tur 8e) */
  // 1) Basılan "Sepete Ekle" düğmesi hatırlanır → düğmenin içinde "✓ Eklendi" gösterilir (ayrı bildirim kutusu yok)
  // 2) Sepet çekmecesi Section Rendering API ile yeniden çizilir (ara toplam / satırlar güncel)
  // 3) Çekmece yandan açılır
  let lastAddBtn = null;
  document.addEventListener('click', (e) => {
    const b = e.target.closest && e.target.closest('button[name="add"], .hdt-product-form__submit, .hdt-custom-atc-btn');
    if (b) lastAddBtn = b;
  }, true);

  function flashAdded(btn) {
    if (!btn || btn.dataset.pgAdded) return;
    const label = (toastRoot() && toastRoot().dataset.addedShort) || '✓';
    const span = btn.querySelector('span') || btn;
    btn.dataset.pgAdded = '1';
    btn.dataset.pgLabel = span.innerHTML;
    btn.classList.add('pg-btn-added');
    span.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m4.5 12.75 6 6 9-13.5"/></svg>' + esc(label);
    setTimeout(() => {
      span.innerHTML = btn.dataset.pgLabel;
      btn.classList.remove('pg-btn-added');
      delete btn.dataset.pgAdded;
      delete btn.dataset.pgLabel;
    }, 1800);
  }

  function drawerSectionId() {
    const host = document.querySelector('hdt-cart-drawer');
    return host && host.getAttribute('section-id');
  }

  // Çekmeceyi verilen Section Rendering HTML'iyle günceller (ek istek yok)
  function applyDrawer(html) {
    const host = document.querySelector('hdt-cart-drawer');
    if (!host || !html) return false;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('#CartDrawer .hdt-dialog-drawer__inner');
    const cur = document.querySelector('#CartDrawer .hdt-dialog-drawer__inner');
    if (!fresh || !cur) return false;
    cur.innerHTML = fresh.innerHTML;
    const freshHost = doc.querySelector('hdt-cart-drawer');
    if (freshHost) ['data-count', 'data-total-price'].forEach((a) => { if (freshHost.hasAttribute(a)) host.setAttribute(a, freshHost.getAttribute(a)); });
    return true;
  }

  async function refreshDrawer(sectionsFromResponse) {
    const sid = drawerSectionId();
    if (!sid) return;
    // Sepete ekleme yanıtı çekmece bölümünü zaten içeriyorsa ikinci istek atılmaz
    if (sectionsFromResponse && sectionsFromResponse[sid] && applyDrawer(sectionsFromResponse[sid])) return;
    try {
      const res = await fetch(`${ROOT}?sections=${encodeURIComponent(sid)}`, { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      const json = await res.json();
      applyDrawer(json[sid] || '');
    } catch (_) { /* ağ hatası: çekmece eski haliyle açılır, sepet sayfası doğru kalır */ }
  }

  function openDrawer() {
    const dlg = document.getElementById('CartDrawer');
    if (isOpen(dlg)) return true;
    const trigger = document.querySelector('[data-smart-header-cart-trigger]');
    if (trigger) { trigger.click(); return true; }
    if (dlg && typeof dlg.showModal === 'function') { dlg.showModal(); return true; }
    return false;
  }

  document.addEventListener('cart:update', async (e) => {
    const detail = e.detail || {};
    if (detail.source !== 'product-form-component') return;
    const data = detail.cartData;
    if (!data || data.status) return;

    closeProductModals();
    bumpCartIcon();
    flashAdded(lastAddBtn);
    lastAddBtn = null;

    // Tur 10: gecikme 600 → 250 ms; çekmece HTML'i yanıtta varsa ek istek yok
    // Masaüstünde çekmece yandan açılır, düğme görünür kalır → bekleme yok; mobilde çekmece tam ekran → 200 ms "Eklendi" görünür
    const wait = window.matchMedia('(max-width: 749px)').matches ? 200 : 0;
    await Promise.all([refreshDrawer(data.sections), new Promise((r) => setTimeout(r, wait))]);
    // Çekmece yoksa / açılamazsa eski bildirim yedek olarak kalır
    if (!openDrawer()) {
      const info = addedItem(data);
      if (info) showToast(info);
    }
  });

  window.addEventListener('cart:error', (e) => {
    const message = e.detail?.data?.message;
    if (!message) return;
    closeProductModals();
    showToast({ error: message });
  });

  /* ------------------------------------------------- birleştirilmiş satırlar */
  // Sepet çekmecesi ve sepet sayfası bölümleri (görünenler)
  function cartSectionIds() {
    const ids = new Set();
    document.querySelectorAll('hdt-cart-drawer[section-id], [ref="hdt-cart"][section-id]').forEach((el) => ids.add(el.getAttribute('section-id')));
    return [...ids].filter(Boolean);
  }

  // Tur 10: satır anahtarları DOM'dan okunur (önceden önce /cart.js çekiliyordu) ve tek istekte
  // hem sepet güncellenir hem de bölümlerin yeni HTML'i alınır → 3 ardışık istek yerine 1.
  async function setVariantTotal(row, quantity) {
    const keys = [row.dataset.pgKey, ...String(row.dataset.pgGroup || '').split(',')].map((k) => k && k.trim()).filter(Boolean);
    if (!keys.length) return false;
    const updates = {};
    keys.forEach((k, i) => { updates[k] = i === 0 ? quantity : 0; });
    const sections = cartSectionIds();
    const res = await fetch(`${ROOT}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates, sections, sections_url: window.location.pathname }),
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok || json.status) {
      window.dispatchEvent(new CustomEvent('cart:error', { detail: { data: { message: json.description || json.message || '' } } }));
      return false;
    }
    if (json.sections && sections.every((id) => json.sections[id])) {
      // Temanın sepet bileşenleri (sayfa + çekmece) bu olayla kendini yeni HTML'den çizer
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { source: 'pg-cart-ux', cartData: json } }));
      return true;
    }
    return false;
  }

  let busy = false;
  window.addEventListener(
    'quantity-selector:update',
    async (e) => {
      const row = e.target?.closest?.('[data-pg-group]');
      if (!row || !row.dataset.pgVariant) return;
      // Kalles'in tek satır güncellemesini durdur; grubun tamamını biz güncelleriz.
      e.stopImmediatePropagation();
      if (busy) return;
      busy = true;
      const quantity = Math.max(0, Number(e.detail?.quantity) || 0);
      row.classList.add('pg-is-busy');
      let rendered = false;
      try {
        rendered = await setVariantTotal(row, quantity);
      } catch (err) {
        console.error('[pg-cart-ux]', err);
      } finally {
        busy = false;
        row.classList.remove('pg-is-busy');
        if (!rendered) document.dispatchEvent(new CustomEvent('cart:reload'));
      }
    },
    true
  );
  /* Tur 10: anında geri bildirim — adet / kaldır tıklanınca satır hemen soluklaşır (istek bitene kadar).
     Satır yeniden çizildiğinde sınıf kendiliğinden gider; hata olursa 8 sn sonra kaldırılır. */
  const ROW_SEL = '.hdt-page-cart__item, .hdt-mini-cart__item, hdt-line-item, [data-pg-group]';
  document.addEventListener('click', (e) => {
    const ctl = e.target.closest && e.target.closest('wrapp-remove-item-oncart, .hdt-quantity__button, .hdt-mini-cart__remove');
    if (!ctl) return;
    const row = ctl.closest('tr, li, .hdt-mini-cart__item') || ctl.closest(ROW_SEL);
    if (!row) return;
    // Birleştirilmiş satırda "Kaldır": varyantın tüm satırları tek istekte silinir
    const isRemove = ctl.matches('wrapp-remove-item-oncart, .hdt-mini-cart__remove') || !!ctl.closest('wrapp-remove-item-oncart');
    if (isRemove && row.dataset.pgGroup && row.dataset.pgKey) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (busy) return;
      busy = true;
      row.classList.add('pg-is-busy');
      setVariantTotal(row, 0).then((ok) => { if (!ok) document.dispatchEvent(new CustomEvent('cart:reload')); })
        .catch(() => document.dispatchEvent(new CustomEvent('cart:reload')))
        .finally(() => { busy = false; });
      return;
    }
    // Kaldır: satır kilitlenir; adet +/-: yalnızca görsel (art arda basmaya izin verilir)
    const cls = isRemove ? 'pg-is-busy' : 'pg-is-pending';
    row.classList.add(cls);
    setTimeout(() => row.isConnected && row.classList.remove(cls), 8000);
  }, true);

  // Sepet çekmecesi: "Alışverişe devam et" → temanın kendi kapat düğmesini tetikler (odak/kaydırma kilidi doğru çözülsün)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest && e.target.closest('[data-pg-cart-close]');
    if (!btn) return;
    const dlg = btn.closest('dialog') || document.getElementById('CartDrawer');
    const close = dlg && dlg.querySelector('.hdt-dialog-btn__close');
    if (close) close.click(); else if (dlg && typeof dlg.close === 'function') dlg.close();
  });
})();
